// 登录账户信息
const accountInfo = {
    state: {
        accountId: undefined,
        userName: undefined,
        waterCompany: undefined,
        userRole: undefined,
        token: undefined
    },
    mutations: {
        // 设置账户信息
        SET_ACCOUNTINFO_INFO: (state, params) => {
            state.accountId = params.accountId;
            state.userName = params.userName;
            state.waterCompany = params.waterCompany;
            state.userRole = params.userRole;
            state.token = params.token;
        },
    
        // 设置登出状态
        SET_ACCOUNTINFO_LOGOUT: (state) => {
            state.accountId = undefined;
            state.userName = undefined;
            state.waterCompany = undefined;
            state.userRole = undefined;
            state.token = undefined;
        }
    }
}

export default accountInfo